import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import axiosInstance from '../../../../services/AxiosInstance';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import ExcelImport from '../../../../components/ExcelImport';
import userImport from '../../../../ExcelFiles/userImport.xlsx';
import axios from 'axios';
import InputField from '../../../../components/InputField';
import { Pagination } from '../../../../components';
import TableAddForm from '../../../../components/TableAddForm';
import { CAN_TYPES } from '../../../../Const';
import AllCandidates from './PreUsers';
import CircleLoader from '../../../../components/CircleLoader';

const Candidates = () => {

    let excelheader = ["username", "email"];
    let headers = ["Name", "Email", "Created on", "Status"];
    let cancelToken;
    let addform = [
        { 'name': 'username', 'label': 'Username', 'type': 'short-text', 'addVali': 'min:6', 'required': true },
        { 'name': 'can_type', 'label': 'Candidate Type', 'type': 'dropdown', 'required': true, 'options': CAN_TYPES },
        { 'name': 'email', 'label': 'E-mail', 'type': 'short-text', 'required': true },
    ]

    const [candidates, setCandidates] = useState();
    const [delIds, setDelIds] = useState([]);
    const [excelImport, setexcelImport] = useState(false);
    const [modal, setModal] = useState(false);
    const [input, setInput] = useState();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const getData = (page = 1) => {
        setLoader(true);
        axiosInstance('user/?role__in=4&fields=id,username,first_name,email,date_joined,emailVerified,red_listed,role&page=' + page, { method: "GET" })
            .then(res => {
                setCandidates(res?.data);
            }).catch(err => {
                console.log('err : ', err);
            }).finally(() => {
                setLoader(false);
            })
    }

    const handleDelete = () => {
        swal({
            text: "Are you sure that you want to delete this record?",
            icon: "warning",
            dangerMode: true,
        }).then(willDelete => {
            if (willDelete) {
                axiosInstance(`user/?delete_ids=${delIds.join(",")}`, { method: "DELETE" })
                    .then(res => {
                        if (res?.status === 204) {
                            getData();
                            setDelIds([]);
                            swal("", "Deleted Successfully", "success", { button: "Ok!", })
                        }
                    })
                    .catch(err => swal("", err?.response?.data?.detail, { button: "Ok!", }))
            }
        });
    }

    const handleCloseExport = () => {
        setexcelImport(!excelImport);
        getData();
    }

    const handleSearchChange = async e => {
        // Function to cancel previous request on searching for api optimization
        if (typeof cancelToken != typeof undefined) {
            cancelToken.cancel("Operation canceled due to new request.")
        }
        cancelToken = axios.CancelToken.source()
        try {
            await axiosInstance(
                `user/?role__in=4&fields=id,username,first_name,email,date_joined,emailVerified,red_listed,role&search=${e.target.value}`,
                {
                    method: "GET",
                    cancelToken: cancelToken.token
                }).then(res => {
                    setCandidates(res?.data)
                })
        } finally {
            return candidates
        }
    }

    return (
        <div className="page-content bg-white">
            <div className="content-block">
                <div className="section-full bg-white p-b20">
                    <div className="container">
                        <div className="job-bx browse-job clearfix">
                            <div className="job-bx-title clearfix">
                                <h5 className="font-weight-700 pull-left text-uppercase">Candidates</h5>
                                <div className="float-right">
                                    <button
                                        className="site-button btn-sm ml-3"
                                        onClick={() => (setModal(true))}
                                    >
                                        Add
                                    </button>
                                </div>
                                {
                                    delIds.length > 0 &&
                                    <div className="float-right">
                                        <button
                                            className="site-button btn-sm btn-danger ml-3"
                                            onClick={handleDelete}
                                            title="Click here to delete the records"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                }
                                <div className="float-right">
                                    {
                                        excelheader?.length > 0 &&
                                        <span
                                            className="float-right mt-1 pointer text-primary"
                                            onClick={() => handleCloseExport()}
                                            style={{ fontSize: "18px" }}
                                        >
                                            {excelImport ?
                                                <Link to="#" className="site-button right-arrow button-sm float-right">Back</Link>
                                                : <i className="fa fa-upload"> Import</i>}
                                        </span>
                                    }
                                </div>
                            </div>
                            {
                                excelImport ?
                                    <ExcelImport
                                        headers={excelheader}
                                        url="user-import/"
                                        filePath={userImport}
                                        filename="Candidate Template.xlsx"
                                        handleCloseExport={handleCloseExport}
                                    />
                                    :
                                    <>
                                        {
                                            modal &&
                                            <TableAddForm
                                                setModal={setModal}
                                                title="Candidates"
                                                input={input}
                                                setInput={setInput}
                                                addform={addform}
                                                url="user/"
                                                getData={getData}
                                            />
                                        }
                                        {
                                            loader ?
                                                <CircleLoader />
                                                :
                                                <>
                                                    <InputField
                                                        className="small-input w-25 float-right"
                                                        placeholder='Search...'
                                                        onChange={handleSearchChange}
                                                    />
                                                    <Tabs defaultActiveKey="all" id="uncontrolled-tab-example" className="mb-3">
                                                        <Tab eventKey="all" title="All">
                                                            <AllCandidates header={headers} data={candidates?.results} delIds={delIds} getData={getData}
                                                                pagination={candidates?.pagination} setDelIds={setDelIds} view="candidate-profile" />
                                                        </Tab>
                                                        <Tab eventKey="Profile Updated" title="Profile Updated">
                                                            <AllCandidates header={headers} delIds={delIds} pagination={candidates?.pagination} getData={getData}
                                                                data={candidates?.results?.filter(item => item.first_name !== '')} setDelIds={setDelIds} view="candidate-profile" />
                                                        </Tab>
                                                        <Tab eventKey="Approved" title="Approved">
                                                            <AllCandidates header={headers} delIds={delIds} pagination={candidates?.pagination} getData={getData} view="candidate-profile"
                                                                data={candidates?.results?.filter(item => item.joc_approve_status === 'Approved')} setDelIds={setDelIds} />
                                                        </Tab>
                                                        <Tab eventKey="Denied" title="Denied">
                                                            <AllCandidates header={headers} delIds={delIds} pagination={candidates?.pagination} getData={getData} view="candidate-profile"
                                                                data={candidates?.results?.filter(item => item.joc_approve_status === 'Denied')} setDelIds={setDelIds} />
                                                        </Tab>
                                                        <Tab eventKey="Red Listed" title="Red Listed">
                                                            <AllCandidates header={headers} delIds={delIds} pagination={candidates?.pagination} getData={getData}
                                                                data={candidates?.results?.filter(item => item.red_listed)} setDelIds={setDelIds} view="candidate-profile" />
                                                        </Tab>
                                                    </Tabs>
                                                </>
                                        }
                                    </>
                            }
                            {candidates?.pagination && <Pagination data={candidates} getData={getData} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Candidates;